/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

export enum WasteAssignmentType {
  SetupWaste = 'SetupWaste',
  ProductionOrderWaste = 'ProductionOrderWaste',
  ContainerWaste = 'ContainerWaste'
}
